import { Caption1, Card, CardHeader, makeStyles, Text, tokens } from "@fluentui/react-components";
import ITestimonial from "../../../models/testimonial/ITestimonial";
import { useTranslation } from "react-i18next";
import { MotionLazyScroll } from "../../../components/motion/MotionLazyScroll";
import IClient from "../../../models/client/IClient";

const useStyles = makeStyles({
    root: {
        display: "flex",
        alignSelf: "stretch"
    },
    card: {
        width: "100%",
        maxWidth: "500px",
        paddingTop: "1rem",
        paddingBottom: "1.5rem",

        "@media (max-width: 1200px)": {
            maxWidth: "100%",
        }
    },
    quote: {
        margin: "auto",
        fontSize: "1rem",
        display: "flex",

        "&::before": {
            content: '"“"',
            display: "inline-block",
            marginRight: "0.5em",
            fontSize: "2rem",
        },

        "&::after": {
            content: '"”"',
            display: "inline-block",
            marginLeft: "0.5em",
            fontSize: "2rem",
        },
    },
    headerImage: {
        borderRadius: "4px",
        maxWidth: "44px",
        maxHeight: "44px",
    },
    caption: {
        color: tokens.colorNeutralForeground3,
    },
    stats: {
        margin: "auto 0 0 0",
        paddingTop: "1rem",
        color: "#666",
        display: "flex",
        justifyContent: "space-between",
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,

        "& span > span": {
            fontWeight: "bold"
        },

        "@media only screen and (max-width: 575px)": {
            display: "block",

            "& > span": {
                display: "block"
            }
        }
    }
});

export default function Testimonial(props: { testimonial: ITestimonial; client?: IClient }) {
    const { t } = useTranslation("testimonials");
    const { testimonial, client } = props;
    const styles = useStyles();

    const header = <Text weight="semibold">{client?.name}</Text>,
        description = (
            <Caption1 className={styles.caption}>
                <strong>{testimonial.contact.name}, </strong> {testimonial.contact.position}
            </Caption1>
        );

    const logo = client?.logo?.url ? (
        <img
            className={styles.headerImage}
            src={client.logo.url}
            alt={client.name}
            />
    ) : undefined;

    const date = new Date(testimonial.date),
        dateStr = date.toLocaleDateString(undefined, { month: "short", year: "numeric" })

    return (
        <MotionLazyScroll className={styles.root}>
            <Card className={styles.card}>
                <CardHeader image={logo} header={header} description={description} />
                <div className={styles.quote} dangerouslySetInnerHTML={{ __html: testimonial.content }} />
                <div className={styles.stats}>
                    <span>
                        {dateStr}
                    </span>
                    <span dangerouslySetInnerHTML={{ __html: t("stats.industry", { industry: client?.industry ?? "" }) }} />
                    <span dangerouslySetInnerHTML={{ __html: t("stats.size", { size: client?.size ?? "" }) }} />
                </div>
            </Card>
        </MotionLazyScroll>
    );
}